import {StyledListItem} from "@/shared/StyledComponents";
import React, {ReactElement} from "react";
import {Resource, RESOURCE_TYPE_KTM} from "@/fyneai-shared/types";

export function ResourcesListView({resources, selectedResource, setSelectedResource}: {
  resources: Resource[],
  selectedResource: Resource,
  setSelectedResource: (resource: Resource) => void
}): ReactElement {
  return <>
    {resources.map((resource) => <StyledListItem
      onClick={() => setSelectedResource(resource)}
      selected={resource === selectedResource}
      key={resource.getResourceNode().id}
      icon={RESOURCE_TYPE_KTM.findMetadata(resource.getResourceNode().type).iconType}
      title={resource.name}
    />)}
  </>;
}
